// EventIds for which we don't want ticket-assign ON

const blackList: number[] = [184097,191093,191142];

export const isEventBlackListed = (eventId: number): boolean => blackList.includes(eventId);